import { Component, inject } from '@angular/core';  
import { TimeCard, TimekeepingService } from '@ftr/owa-timekeeping';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { distinctUntilChanged } from "rxjs";


@Component({
    selector: 'reported-timecard-status',
    templateUrl: './reported-timecard-status.component.html',
    styleUrls: ['./reported-timecard-status.component.scss'],
    imports: []
})
export class ReportedTimeCardStatusComponent {
    private _timeKeepingService = inject(TimekeepingService);

    shouldShowBanner: boolean = false;
    hasTimeCards: boolean = false;
    constructor() {
        this._timeKeepingService.isReportedStartDateCurrent.pipe(
            distinctUntilChanged()
          ).subscribe((startDateIsCurrent) => {
            this.shouldShowBanner = !startDateIsCurrent;
          });

        this._timeKeepingService.currentTimeCardsSubject.pipe(
            distinctUntilChanged()
          ).subscribe( (timecard: Array<TimeCard>) => {
            this.hasTimeCards = !!timecard?.length;
          });
    }
}